/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Cases_LabelInputs */

const en_dashboard_cases_label = /** @type {(inputs: Dashboard_Cases_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases`)
};

const pt_br2_dashboard_cases_label = /** @type {(inputs: Dashboard_Cases_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos`)
};

/**
* | output |
* | --- |
* | "Cases" |
*
* @param {Dashboard_Cases_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_cases_label = /** @type {((inputs?: Dashboard_Cases_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Cases_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_cases_label(inputs)
	return pt_br2_dashboard_cases_label(inputs)
});